export default __webpack_public_path__ + "static/f31-f1fe1adc6b289bd0dcde393c93b87aff.svg";